<template>
  <div class="tw-text-center tw-mb-4">
    <div class="tw-text-lg tw-font-medium">
      {{ I18n.t('components.templates.async_render_error.title') }}
    </div>
    <div class="tw-text-sm">
      {{ I18n.t('components.templates.async_render_error.description') }}
    </div>
  </div>
  <sf-banner-page
    :title="I18n.t('components.templates.async_render_error.banner.title')"
    variant="success"
    has-long-text
    is-full-width
    class="tw-mb-2"
  >
    <span
      v-dompurify-html="
        I18n.t(
          'components.templates.async_render_error.banner.description_html'
        )
      "
    />
  </sf-banner-page>

  <div
    v-if="canBeDeleted"
    class="
      tw-flex
      tw-items-center
      tw-justify-between
      tw-mb-2
      tw-bg-sf-neutral-subtle-2
      tw-p-1
      tw-pl-2
      tw-rounded-lg
    "
  >
    <div>
      <span class="fa fa-solid fa-trash-can tw-mr-1"></span>
      <span>{{
        I18n.t('components.templates.async_render_error.delete_row.title')
      }}</span>
    </div>
    <SfButton :variant="'default'" :small="true" @click="handleClick">
      {{
        I18n.t(
          'components.templates.async_render_error.delete_row.button_label'
        )
      }}
    </SfButton>
  </div>

  <div
    class="
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-sf-neutral-subtle-2
      tw-p-1
      tw-pl-2
      tw-rounded-lg
    "
  >
    <div>
      <span class="fa fa-solid fa-eye tw-mr-1"></span>
      <span>{{
        I18n.t('components.templates.async_render_error.review_row.title')
      }}</span>
    </div>
    <SfButton :variant="'default'" :small="true" @click="openUrl">
      {{
        I18n.t(
          'components.templates.async_render_error.review_row.button_label'
        )
      }}
    </SfButton>
  </div>
</template>

<script setup lang="ts">
import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { deleteReconcilliationDetails } from '@app/application/reconciliation/utils'
import SfBannerPage from '@app/shared/vue/components/sf-banner/sf-banner-page.vue'

interface Props {
  canBeDeleted?: boolean
  reviewPath: string
  url: string
  message: string
  confirmationName: string
}

const {
  canBeDeleted = false,
  reviewPath,
  url,
  message,
  confirmationName,
} = defineProps<Props>()

const I18n = useI18n()

function handleClick() {
  deleteReconcilliationDetails(url, message, confirmationName)
}

function openUrl() {
  window.Turbolinks.visit(reviewPath)
}
</script>
